import {TextField, TextFieldProps} from '@mui/material'
import {ChangeEvent, useCallback} from 'react'
import {useControlledFilterTableContainerProps} from '../ControlledFilterTableContainer'
import {useControlledFilterTableHelpers} from '../useControlledFilterTableUtils'

export type SearchInputFilterProps = Omit<TextFieldProps, 'onChange' | 'value'>

export const SearchInputFilter = ({
  size = 'small',
  placeholder = 'Search',
  ...props
}: SearchInputFilterProps) => {
  const {filters, onFilter} = useControlledFilterTableContainerProps()
  const {search} = useControlledFilterTableHelpers({filters, onFilter})

  const handleSearch = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      search(e.target.value)
    },
    [search]
  )

  return (
    <TextField
      {...props}
      size={size}
      placeholder={placeholder}
      onChange={handleSearch}
      value={(filters.filters?.search || '') as string}
    />
  )
}
